<template>
  <div
    class="bg-paper text-ink flex min-h-screen flex-col pb-[env(safe-area-inset-bottom,0px)] transition-colors"
  >
    <RouterView />
  </div>
</template>
